import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import Settings from "./Settings";
import Common from "./Common";
import Admin from "./Admin";

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    settings: Settings,
    common: Common,
    admin: Admin,
  });

export default createRootReducer;
